'use client';
import { JSX, ReactNode, useEffect, useState } from 'react';
import { Portal } from '$/components/Portal';

/**
 * Component that sticks a component to the bottom of the screen and renders
 * a placeholder of equal size to keep scrolling working correctly.
 */
export function StickyFooter({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const [placeholder, setPlaceholder] = useState<HTMLDivElement | null>();
  const [footer, setFooter] = useState<HTMLDivElement | null>();

  useEffect(() => {
    if (!placeholder || !footer) return;
    placeholder.style.height = `${footer.offsetHeight}px`;
    const observer = new ResizeObserver(() => {
      placeholder.style.height = `${footer.offsetHeight}px`;
    });
    observer.observe(footer);
    return () => observer.unobserve(footer);
  }, [placeholder, footer]);

  return (
    <div ref={(node) => setPlaceholder(node)}>
      <Portal>
        <div
          ref={(node) => setFooter(node)}
          className="fixed inset-x-0 bottom-0"
        >
          {children}
        </div>
      </Portal>
    </div>
  );
}
